import ProductDetailBlade from "@/pages/products/detailBlades/ProductDetailBlade";
import NavigationWidget from "@/pages/products/detailWidgets/NavigationWidget";

/** hopefully we implement using an actual step ID or something from step to match these, such as lifestyle_images, NA_Color_Options...
 * and not a keyless label string from our custom json **/

const pdpBlades = {
    product_detail_nav: {component: NavigationWidget, props: {}},
    product_detail_gallery: {component: ProductDetailBlade, props: {stepKey: 'Gallery'}},
    product_detail_features: {component: ProductDetailBlade, props: {stepKey: 'Features'}},
    product_detail_options: {component: ProductDetailBlade, props: {stepKey: 'Additional Options'}},
    product_detail_colors: {component: ProductDetailBlade, props: {stepKey: 'Colors'}},
    product_detail_wood: {component: ProductDetailBlade, props: {stepKey: 'Wood'}},
    product_detail_screen_color: {component: ProductDetailBlade, props: {stepKey: 'Color Options'}},
    product_detail_screen_application: {component: ProductDetailBlade, props: {stepKey: 'Applications'}},
    product_detail_hardware: {component: ProductDetailBlade, props: {stepKey: 'Hardware'}},
    product_detail_mounting: {component: ProductDetailBlade, props: {stepKey: 'Mounting'}},
    product_detail_glass: {component: ProductDetailBlade, props: {stepKey: 'Glass'}},
    product_detail_docs: {component: ProductDetailBlade, props: {stepKey: 'Sizing, Technical, Performance'}},
};

export default pdpBlades
